function SaveProgressBar({ progress }) {
  if (!progress?.visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 20,
        right: 20,
        bottom: 20,
        background: "#fff",
        borderRadius: 12,
        padding: 14,
        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <div style={{ fontWeight: 600 }}>{progress.label}</div>
        {/* <div style={{ fontVariantNumeric: "tabular-nums" }}>
          {progress.current}/{progress.total} ({progress.percent}%)
        </div> */}
      </div>

      <div style={{ height: 10, background: "#eee", borderRadius: 999 }}>
        <div
          style={{
            height: 10,
            width: `${progress.percent}%`,
            background: "#0d6efd",
            borderRadius: 999,
            transition: "width 120ms linear",
          }}
        />
      </div>
    </div>
  );
}

export default SaveProgressBar;
